import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@components/button';
import { CsIconModule } from '@components/icon';
import { ProductListComponent } from './product-list.component';
import { SwiperModule } from 'swiper/angular';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';

@NgModule({ imports: [CommonModule,
  CsIconModule,
  ButtonModule,
  SwiperModule,
  ButtonCtaComponent,
],
declarations: [ProductListComponent],
exports: [ProductListComponent] })
export class ProductListModule {}
